import { makeVar } from '@apollo/client';
import { LineItemV2SortOptions } from '../../../graphql/types';
import { buildVars } from '../../FilteredTable/vars';
import { NUM_ITEMS } from './constants';
import { defaultSortState } from './defaults';
import { LineItemFilters } from './types';

export const vars = buildVars<LineItemV2SortOptions, LineItemFilters, number>({
  defaultSortState,
  defaultHiddenColumns: [],
  pageSize: NUM_ITEMS,
  defaultFiltersState: { filterQuery: undefined },
});

export const { sortVar, paginationVar, filtersVar, initialLoadingVar, multiSelectVar, hiddenColumnsVar } =
  vars;

export const expandedIdVar = makeVar<number | undefined>(undefined);
